import React, { useState } from "react";
import "./Common_Category_Card.css";

const Common_Category_Card = ({ imgSrc, title ,onClick}) => {

  return (
    <>
      <section
        className="Common_Category_Card"
        onClick={onClick}
      >
        
        <div className="bg_holder">
          <div className="img_holder">
            <img src={process.env.PUBLIC_URL + imgSrc} className="cat_img" />
          </div>
        </div>
        <p className="cat_name">{title}</p>
      </section>

    </>
  );
};

export default Common_Category_Card;
